module.exports = __webpack_public_path__ + "img/北京冷库 (2).9ab6cf7c.jpg";